registerComponent("pages/investments", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Sem comportamento próprio — em 2020 também não tinha: o arquivo era um
 * `$(component)` comentado. A página é só LESS.
 */

});
